import React from "react";
import "./Activity.css";
import ActivityCard from "./ActivityCard/ActivityCard";
import Activity_tabs from "./Activity_tabs/Activity_tabs";
import { useNavigate } from "react-router-dom";
import No_data from "../Common/No_data/No_data";

function Activity() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Activity">
        {/* Top Header */}
        <div className="Activity_header">
          <div className="logo_holder">
            <img
              src="/assets/images/logo/money_king.png"
              className="logo_img"
              alt="logo"
            />
          </div>

          <div className="bonus_row">
            <div className="bonus_col">
              <p>Today's Bonus</p>
              <h3>₹0.19</h3>
            </div>

            <div className="divider"></div>

            <div className="bonus_col">
              <p>Total Bonus</p>
              <h3>₹7,789.90</h3>
            </div>
          </div>

          <button
            className="bonus_btn"
            onClick={() => navigate("/bonus-details")}
          >
            Bonus Details
          </button>
        </div>
        <div className="container">
          <Activity_tabs />

          {/* <div className="coming_soon_div">
            <p className="soon_text">This section is coming soon</p>
          </div> */}

          <div className="coming-soon-overlay">
            <div className="coming-soon-box">
              <div className="coming-soon-icon">🎁</div>

              <h1> 🚀 Stay tuned for upcoming updates</h1>

              {/* <p>
                We're working on exciting rewards, exclusive offers, and special
                promotions just for you.
              </p>

              <div className="coming-soon-badge">
                🚀 Stay tuned for upcoming updates
              </div> */}

              <button
                className="coming-soon-btn"
                onClick={() => window.history.back("/")}
              >
                Go Back
              </button>
            </div>
          </div>

          {/* Section Cards */}
          <div className="Activity_sections">
            <ActivityCard image="/assets/images/activity/Gift_Card.png" />

            <ActivityCard image="/assets/images/activity/Bonus_Card.png" />
          </div>

          <No_data />
        </div>
      </section>
    </>
  );
}

export default Activity;
